import * as Yup from 'yup';
import { TFunction } from 'react-i18next';

import ShippingMethod from 'model/ShippingMethod';

export default (t: TFunction): Yup.BaseSchema =>
  Yup.object().shape({
    shippingMethod: Yup.string().required(t('SHIPPING_SELECT_METHOD_REQUIRED')),
    addressType: Yup.string().when('shippingMethod', {
      is: (value: string) => {
        return (
          value === ShippingMethod.colieco ||
          value === ShippingMethod.colissimo ||
          value === ShippingMethod.standardPackage
        );
      },
      then: Yup.string().required(t('SHIPPING_SELECT_ADDRESS_REQUIRED')),
    }),
    relayPoint: Yup.object()
      .nullable()
      .when('shippingMethod', {
        is: (value: string) => value === ShippingMethod.relay,
        then: Yup.object()
          .nullable()
          .required(t('SHIPPING_SELECT_PICKUP_REQUIRED')),
      }),
    mondialRelayPoint: Yup.object()
      .nullable()
      .when('shippingMethod', {
        is: (value: string) => value === ShippingMethod.mondialRelay,
        then: Yup.object()
          .nullable()
          .required(t('SHIPPING_SELECT_PICKUP_REQUIRED')),
      }),
  });
